// import '@mdi/font/css/materialdesignicons.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import ru from 'vuetify/es5/locale/ru';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { ru },
    current: 'ru',
  },
  theme: {
    dark: true
  },
  icons: {
    iconfont: 'md',
    values: {
      search: 'mdi-magnify',
      add: 'mdi-plus',
      close: 'mdi-close'
    }
  }
});
